import MenuItem from "./../../../core/components/menu/MenuItem";
import i18n from '../../../shared/i18n'
import Cls from "@/modules/setup/cls/Cls";

let routes = [{
  path: 'custom-lot-sequence',
  name: 'custom_lot_sequence',
  component: Cls,
  meta: {
    requiresAuth: true
  }
}];

export default {
  menuItem: new MenuItem('/custom-lot-sequence', i18n.t('CLS'), 40, 'sort'),
  routes: routes
}
